import { render } from "./ViewEachCustomer.vue?vue&type=template&id=493242ca"
import script from "./ViewEachCustomer.vue?vue&type=script&lang=js"
export * from "./ViewEachCustomer.vue?vue&type=script&lang=js"

import "./ViewEachCustomer.vue?vue&type=style&index=0&id=493242ca&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__